import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter, DialogClose } from "./ui/dialog";
import { Button } from "./ui/button";
import { useTranslation } from "react-i18next";
import { ScrollArea } from "./ui/scroll-area";
import { FileText } from "lucide-react";

const CustomerAgreement = () => {
    const { t } = useTranslation("settings");
    return (
        <>
            <Dialog >
                <DialogTrigger asChild>
                    <span className="underline cursor-pointer hover:text-[--accent-primary] transition-colors text-[--accent-primary]">Customer Agreement</span>
                </DialogTrigger>
                <DialogContent className="max-w-4xl max-h-[85vh] flex flex-col">
                    <DialogHeader className="border-b border-border/50 pb-4 flex flex-row items-center gap-4">
                        <div className="flex items-center justify-center p-2 rounded-lg bg-[--accent-primary]/15">
                            <FileText className="h-6 w-6 text-white" />
                        </div>
                        <div className="flex-1">
                            <DialogTitle className="text-xl font-bold">Customer Agreement</DialogTitle>
                            <p className="text-xs text-muted-foreground mt-0.5">Last updated: July 2026</p>
                        </div>
                    </DialogHeader>

                    <ScrollArea className="h-[50vh] pr-4 my-4">
                        <div className="space-y-6 text-sm leading-relaxed text-slate-300">
                            
                            <div className="bg-[#0c1938]/30 border border-[#1d3570]/30 rounded-xl p-4 text-slate-300">
                                <p>
                                    This Customer Agreement (“Agreement”) is entered into with Bytemine Technologies Ltd, trading as “Level2” (“Level2”, “we”, “our”, “us”). By accessing or using our services, you agree to comply with and be bound by this Agreement. If you do not agree, you should not use our services.
                                </p>
                            </div>

                            {/* Section 1 */}
                            <div className="space-y-3">
                                <h3 className="text-base font-semibold text-white flex items-center gap-2 border-l-2 border-[--accent-primary] pl-3">
                                    1. Acceptance of Terms
                                </h3>
                                <div className="space-y-2 text-slate-400 pl-4">
                                    <p>
                                        By using Level2, you agree to be bound by these Terms and Conditions, our Risk disclosure notice, and any additional terms applicable to certain programs in which you may elect to participate. If you do not agree to these terms, you must cease use of the platform immediately.
                                    </p>
                                </div>
                            </div>

                            {/* Section 2 */}
                            <div className="space-y-3">
                                <h3 className="text-base font-semibold text-white flex items-center gap-2 border-l-2 border-[--accent-primary] pl-3">
                                    2. Services Provided
                                </h3>
                                <div className="space-y-2 text-slate-400 pl-4">
                                    <p>
                                        Level2 (a trading name of Bytemine Technologies Ltd) offers a range of services related to automated trading, including but not limited to trading algorithms, market analysis tools, backtesting and educational resources. All services are subject to change without notice at the discretion of Level2.
                                    </p>
                                </div>
                            </div>

                            {/* Section 3 */}
                            <div className="space-y-3">
                                <h3 className="text-base font-semibold text-white flex items-center gap-2 border-l-2 border-[--accent-primary] pl-3">
                                    3. Intellectual Property
                                </h3>
                                <div className="space-y-2 text-slate-400 pl-4">
                                    <ul className="list-disc pl-5 space-y-1.5">
                                        <li>All content on the platform, including text, graphics, logos, and software, is the property of Bytemine Technologies Ltd trading as Level2, or its content suppliers and is protected by intellectual property laws.</li>
                                        <li>You may not reproduce, distribute, or create derivative works from any content on the platform without express written permission from Level2.</li>
                                    </ul>
                                </div>
                            </div>

                            {/* Section 4 */}
                            <div className="space-y-3">
                                <h3 className="text-base font-semibold text-white flex items-center gap-2 border-l-2 border-[--accent-primary] pl-3">
                                    4. Indemnification
                                </h3>
                                <div className="space-y-2 text-slate-400 pl-4">
                                    <p>
                                        You agree to indemnify, defend, and hold harmless Bytemine Technologies Ltd trading as Level2, its affiliates, officers, directors, employees, agents, and licensors from and against any and all claims, liabilities, damages, losses, or expenses, including reasonable attorneys&apos; fees, arising out of or in any way connected with your access to or use of the platform.
                                    </p>
                                </div>
                            </div>

                        </div>
                    </ScrollArea>

                    <DialogFooter className="border-t border-border/50 pt-4 flex justify-end">
                        <DialogClose asChild>
                            <Button type="button" className="bg-[--accent-primary] text-white hover:bg-[--accent-primary]/90 px-6 py-2 rounded-md transition-all duration-300">
                                Accept &amp; Close
                            </Button>
                        </DialogClose>
                    </DialogFooter>
                </DialogContent>
            </Dialog >
        </>
    )
}
export default CustomerAgreement;
